import clsx from 'clsx';

import { Content } from '@/lib';
import { DataLayer } from '@/components';
import styles from './ButtonDownload.module.scss';
import { Row } from '../../Row';

export function ButtonDownload({ text, url, target, fluid }: Content.WithFluid<Content.ButtonDownload>) {
  return (
    <Row className={clsx(fluid && styles.fluid)}>
      <a
        href={url}
        target={target}
        className={clsx(styles.button)}
        onClick={() => {
          DataLayer.pushDownloadTemplateHelpdeskClickEvent();
        }}
      >
        <span className="text text-sm text-bold">{text}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.0001 10.7V17H3.00012V3H9.30012" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
          <path d="M12.0001 3H17.0001V8" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
          <path d="M17.0001 3L8.00012 12" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
      </a>
    </Row>
  );
}
